import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { Suspense, useCallback, useContext, useMemo, useState, } from 'preact/compat';
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import { optionsDefaults, PriceInputOptionsCtx } from '@widgets/PriceInput/context/Options';
import LoadingSpinner from '@widgets/shared/components/LoadingSpinner';
import Button from '@widgets/shared/components/NumberInput/styles/button';
import Input from '@widgets/shared/components/NumberInput/styles/control';
import PriceCard from '@widgets/PriceInput/components';
import { CardWrapper, FieldWrapper, NumberInputWrapper } from './styles';
function Element() {
    const { items, min, max, initialQuantity, } = useContext(PriceInputOptionsCtx);
    const [quantity, setQuantity] = useState(initialQuantity);
    const isPrevButtonUsable = useMemo(() => quantity !== min, [quantity, min]);
    const isNextButtonUsable = useMemo(() => quantity !== max, [quantity, max]);
    const decrease = useCallback(() => {
        const newValue = quantity - 1;
        if (newValue <= min) {
            return setQuantity(min);
        }
        if (newValue >= max) {
            return setQuantity(max);
        }
        return setQuantity(newValue);
    }, [quantity, min]);
    const increase = useCallback(() => {
        const newValue = quantity + 1;
        if (newValue <= min) {
            return setQuantity(min);
        }
        if (newValue >= max) {
            return setQuantity(max);
        }
        return setQuantity(newValue);
    }, [quantity, max, min]);
    const handleInputChange = useCallback((e) => {
        const newValue = parseInt(e.currentTarget.value, 10);
        if (Number.isNaN(newValue)) {
            return setQuantity(min);
        }
        if (newValue >= max) {
            console.log(newValue);
            return setQuantity(max);
        }
        if (newValue <= min) {
            return setQuantity(min);
        }
        return setQuantity(newValue);
    }, [quantity, setQuantity, min, max]);
    return (_jsxs(_Fragment, { children: [_jsxs(NumberInputWrapper, { children: [_jsx("span", { className: "h6", children: "Visitors" }), _jsxs(FieldWrapper, { children: [_jsxs(Button.Element, { isDecrease: true, type: "button", disabled: !isPrevButtonUsable, onClick: decrease, children: [_jsx(Button.Label, { children: "Decrease" }), _jsx(Button.Minus, { fill: "var(--primary-medium)" })] }), _jsx(Input.Wrapper, { children: _jsx(Input.Element, { type: "number", name: "quantity", value: quantity, onChange: handleInputChange }) }), _jsxs(Button.Element, { type: "button", onClick: increase, disabled: !isNextButtonUsable, children: [_jsx(Button.Label, { children: "Increase" }), _jsx(Button.Plus, { fill: "var(--primary-medium)" })] })] })] }), _jsx(CardWrapper, { children: items.map((item, index) => (_jsx(PriceCard, { ...item, quantity: quantity }))) })] }));
}
function PriceInput(props) {
    const { dataset } = props;
    const formattedAttributes = convertDataAttributes(dataset ?? {});
    const options = useMemo(() => ({
        ...optionsDefaults,
        ...formattedAttributes,
    }), [formattedAttributes]);
    return (_jsx(Suspense, { fallback: LoadingSpinner, children: _jsx(PriceInputOptionsCtx.Provider, { value: options, children: _jsx(Element, {}) }) }));
}
export default PriceInput;
